import React, { useEffect, useContext } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { WizardPage } from '@xengage/gw-portals-wizard-react';
import { useTranslator } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { MLConfirmationPolicyDetailsBox } from 'ml-capability-policychange-common-react';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import { MLQuoteNameUtil } from 'ml-portals-util-js';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import appConfig from 'app-config';
import PolChangeTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PolChangeTrackEvent.jsx';
import { Identify  } from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/TrackEvent';

import metadata from './MLCancellationConfirmationPage.metadata.json5';
import messages from './MLCancellationConfirmationPage.messages';
import styles from './MLCancellationConfirmationPage.module.scss'

import { IntlContext } from '@jutro/legacy/locale';

function MLCancellationConfirmationPage(props) {
    const {
        updateWizardData, wizardData, history
    } = props;
    const { submissionVM } = wizardData;
    const intl = useContext(IntlContext);
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const policy = submissionVM.policy.value;
    const isGPA = appConfig.portalCode === 'GPA';

    const AlertService = MLNotificationBlockUtil();

    useEffect(() => {
        Identify('Cancellation Step Reached', {step: 'Confirmation Screen'}, submissionVM, authHeader)        
    }, [])
    
    useEffect(() => {
        const productName = MLQuoteNameUtil.getProductName(policy.product.publicID);
        AlertService.addSuccessAlert(translator(messages.policyCancelled, {policyType: productName}), 'policyCancellationScreen');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isGPA) {
            PolChangeTrackEvent('Cancel Step Reached', false, submissionVM, authHeader, { step: 'PolChange Cancel Confirmation Screen' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const printConfirmation = () => {
        window.print();
    };

    const goToAccount = () => {
        history.push(`/accounts/${policy.account.accountNumber}/summary`);
    };

    const formatDate = (gwDateVal) => {
        const date = LocalDateUtil.toMidnightDate(gwDateVal);
        return intl.formatDate(date, { year: 'numeric', month: '2-digit', day: '2-digit' })
    };

    const overrideProps = {
        policyDetails: {
            changeTypeLabel: translator(messages.cancel),
            policyNumber: policy.policyNumber,
            paymentMethod: _.get(submissionVM, 'policy.billingDetails_ML.ratingPaymentMethod_ML.value.code'),
            endingIn: policy.billingDetails_ML.last4Digits_ML,
            paymentSchedule: policy.billingDetails_ML.paymentPlan_ML.name,
            insured: policy.account.accountHolder,
            secondaryInsured: _.get(policy, 'secondaryInsured_ML.displayName'),
            effectiveDate: formatDate(submissionVM.effectiveDate.value),
            amount: submissionVM.value.changeInCost
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            printConfirmation,
            goToAccount
        },
        resolveComponentMap: {
            MLConfirmationPolicyDetailsBox
        }
    }

    return (
        <WizardPage
            showCancel={false}
            showNext={false}
            showPrevious={false}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={wizardData}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                
            />
        </WizardPage>
    );
}

export default withRouter(MLCancellationConfirmationPage);